import axios from "axios";
import { API_URL } from "../../../Endpoints";

function getApiBase() {
  if (API_URL) {
    return API_URL.replace(/\/$/, "");
  }
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost"
  ) {
    return "http://localhost:5000";
  }
  return "";
}

/**
 * When `local-dcm.config.json` exists on the machine (gitignored), the backend
 * serves local OP/OPT files. Otherwise returns remote blob-storage URLs.
 */
export async function resolveDicomUrls(remoteUrls) {
  try {
    const { data } = await axios.get(`${getApiBase()}/api/v1/local-dcm/config`);
    if (data?.enabled && Array.isArray(data.urls) && data.urls.length === 2) {
      return data.urls;
    }
  } catch (error) {
    console.warn("[local-dcm] Config check failed — using remote URLs:", error);
  }

  return remoteUrls;
}
